import { TicketIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import moment from "moment";

import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import DownloadButton from "../../../../components/DownloadButton";
import useGetAllSnowflakes from "./hooks/useGetAllSnowflake";
import useGetAllMappedSnowflakes from "./hooks/useGetAllMappedSnowflake";

export const SnowflakeReport: React.FC<any> = () => {
  const { data: snowflakeData, isLoading: snowflakeDataLoading } =
    useGetAllSnowflakes();
  const { data: snowflakeMappedDataCount } = useGetAllMappedSnowflakes();

  type DynamicRow = Record<string, any>;

  function percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
  }

  const exportdata = snowflakeData?.map((row: DynamicRow) => {
    const formattedRow: Record<string, any> = {};
    Object.entries(row).forEach(([key, value]) => {
      if (key === "cdrcLastExecution") {
        if (!value) {
          formattedRow[key] = "";
        } else {
          try {
            formattedRow[key] = moment(value).isValid()
              ? moment(value).format("M/D/YYYY")
              : String(value);
          } catch {
            formattedRow[key] = String(value);
          }
        }
        return;
      }
      if (key === "tableData") return;
      const yesNoColumns = ["isInProduction"];
      if (yesNoColumns.includes(key)) {
        formattedRow[key] = value ? "Yes" : "No";
      } else if (key.toLowerCase().includes("date") && value) {
        formattedRow[key] = moment(value).isValid()
          ? moment(value).format("M/D/YYYY hh:mm A")
          : String(value);
      } else {
        formattedRow[key] = value;
      }
    });
    return formattedRow;
  });

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "TableauAllDataReport_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };

  const snowflakeColumns =
    snowflakeData && snowflakeData.length > 0
      ? Object.keys(snowflakeData[0])
          .filter((key) => key !== "tableData")
          .map((key) => ({
            title: key
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase()),
            field: key,
            render: (row: any) => {
              const value = row[key];

              if (key === "isInProduction") {
                return value ? "Yes" : "No";
              }

              if (key === "cdrcLastExecution") {
                if (!value) return ""; // handle null/undefined

                try {
                  return moment(value).isValid()
                    ? moment(value).format("M/D/YYYY hh:mm A")
                    : String(value);
                } catch {
                  return String(value);
                }
              }

              if (value === null || value === undefined) return "";

              // Format dates
              if (key.toLowerCase().includes("date")) {
                try {
                  return moment(value).format("M/D/YYYY hh:mm A"); //moment(value).format("M/D/YYYY hh:mm A")
                } catch {
                  return String(value);
                }
              }

              // Convert objects or arrays to JSON strings
              if (typeof value === "object") {
                return JSON.stringify(value);
              }

              return value;
            },
          }))
      : [];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <TicketIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Tableau Data
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                {"Tableau - All Data Report"}
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-reportsColor text-base font-semibold">
                {snowflakeData?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata()}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={snowflakeData}
            isLoading={snowflakeDataLoading}
            columns={snowflakeColumns}
            showTitle={false}
            toolbarSearch={true}
            showToolbar={true}
          />
        </div>
      </div>
    </div>
  );
};
